import { combineReducers } from 'redux'
import account from './accountReducer'
import content from './contentReducer'

const rootReducer = combineReducers({
    account,
    content,
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js